export default "__VITE_ASSET__C3bLUdM___"